export {
  getAmplitudeDeviceId as getDeviceId,
  getAmplitudeSessionId as getSessionId,
  getAmplitudeUserId as getUserId,
  setAmplitudeDeviceId as setDeviceId,
  setAmplitudeOptOut as setOptOut,
  setAmplitudeSessionId as setSessionId,
  setAmplitudeUserId as setUserId,
} from './client.web';
export { initAmplitudeWithPluginsForPlatform } from './initialize.web';
